import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Modal } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import TableWidget from '../../TableWidget.js';
import WagetypeRefetch from '../../WagetypeRefetch.js';
import Button from '~/components/CustomButton/CustomButton.jsx';
import AddEditAbsenceTypeForm from './absenceTypesForm.js';

//elements
import WageTypeDisplay from '~/elements/WageTypeDisplay.js';

//constants
import { WAGE_TYPE_HOURLY_FALLBACK_NOTE, payrollIntegrationOptions } from '~/utils/constants';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

class AbsentTypes extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const extendedRules = Object.assign({}, currentEntity.client.data.extendedRules);
        const payrollIntegration = props.commonStore?.config?.integration_details || null;
        this.state = {
            absent_types: extendedRules.absent_types || [],
            wageType: props.commonStore.getWageTypesAccordingToIntegrations(payrollIntegration, 'ab') || [],
            lastUpdated: props.commonStore.getWageTypesAccordingToIntegrations(payrollIntegration, 'last_updated') || null,
            // absenceCode: props.commonStore.getWageTypesAccordingToIntegrations(payrollIntegration, 'absenceCode') || [],
            isLoadingWageTypes: false,
            showAllWageTypes: false,
            isEdit: false,
            editData: {}
        }
        this.toggleModal = this.toggleModal.bind(this);
        this.editAbsenceType = this.editAbsenceType.bind(this);
        this.onSave = this.onSave.bind(this);
        this.refetchWageType = this.refetchWageType.bind(this);
    }

    toggleModal = (value, data) => {
        this.setState({ isEdit: value, editData: data });
    }

    editAbsenceType = (index) => {
        const data = this.state.absent_types[index];
        data.index = index;
        this.toggleModal(true, data);
    }

    onSave = (data) => {
        const { isEdit, editData } = this.state;
        const { commonStore, t } = this.props;
        const { currentEntity } = this.props.clientStore;
        if (data.hasError)
            return commonStore.addNotification(t(data.errors[0].error), null, 'warning');

        const _absent_types = [...this.state.absent_types];
        const fieldsToCheck = [{ field: 'code', name: 'Code' }, { field: 'label', name: 'Label' }];

        for (const { field, name } of fieldsToCheck) {
            const duplicate = _absent_types.find((item, index) => isEdit && editData.index !== undefined && index === editData.index ? false : data[field] == null || data[field] === "" ? false : item[field] === data[field]);
            if (duplicate) return commonStore.addNotification(`${t('Please fill unique value for')} ${t(name)}! ${t("Same value already exists.")}`, null, 'warning');
        }
        if (isEdit && editData.index !== undefined) {
            _absent_types[editData.index] = data;
            delete _absent_types[editData.index].index;
        } else _absent_types.push(data);
        this.setState({ absent_types: _absent_types }, () => {
            currentEntity.client.data.extendedRules['absent_types'] = _absent_types;
            this.toggleModal(false, {});
        });
    }

    refetchWageType = async () => {
        const { commonStore, t } = this.props;
        try {
            await commonStore.refetchWagetypes();
            commonStore.addNotification(t('Successfully refetched wagetypes'), null, 'success');
            const _wagetype = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'ab') || [];
            const _lastUpdated = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'last_updated') || null;
            // const _absenceCode = commonStore.getWageTypesAccordingToIntegrations(commonStore?.config?.integration_details, 'absenceCode') || [];
            this.setState({ wageType: _wagetype, lastUpdated: _lastUpdated, isLoadingWageTypes: false });

        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            this.setState({ isLoadingWageTypes: false });
        }
    }

    render() {
        const { absent_types, wageType, lastUpdated, isLoadingWageTypes, isEdit, showAllWageTypes } = this.state;
        const { t, commonStore } = this.props;
        const effectiveWageType = showAllWageTypes ? commonStore.getAllWageTypesCombined() : wageType;
        const integrationProduct = commonStore?.config?.integration_details?.product;
        const isActivityBased = integrationProduct === payrollIntegrationOptions.XLEDGER || integrationProduct === payrollIntegrationOptions.TRIPLETEX;
        const wageTypeColumnLabel = isActivityBased ? 'Activity' : 'Wage Type';
        let headers = ['code', 'Label'];
        let metaData = [{ field: 'code', type: 'text', placeholder: 'code', required: true, unique: true },
        { field: 'name', type: 'text', placeholder: 'Label', required: true, unique: true }];
        let tableData = absent_types;

        if (wageType?.length) {
            headers = ['code', wageTypeColumnLabel, 'Label'];
            metaData = [{ field: 'code', type: 'text', placeholder: 'code', required: true, unique: true },
            { field: 'wageTypeDisplay', placeholder: wageTypeColumnLabel, html: true },
            { field: 'name', type: 'text', placeholder: 'Label', required: true, unique: true }];
            tableData = absent_types.map(item => ({ ...item, wageTypeDisplay: <WageTypeDisplay wageType={item.payrollWageType} hourlyWageType={item.hourlyPayrollWageType} t={t} /> }));
        }

        // if (commonStore?.config?.integration_details?.product === payrollIntegrationOptions.XLEDGER && absenceCode?.length) {
        //     headers.splice(2, 0, 'Absence Code');
        //     metaData.splice(2, 0, { field: 'absenceCode', type: 'select', placeholder: 'Absence Code', select: true, data: absenceCode, required: true });
        // }

        return (
            <div>
                <Row className='mt-2'>
                    <Col xs={12} className='d-flex justify-content-end'>
                        <Button wd fill onClick={() => this.toggleModal(true, {})}>
                            <i className="fa fa-plus-circle fa-xl margin-right-10" /> {t('Add new')}
                        </Button>
                    </Col>
                </Row>
                {!!wageType.length &&
                    <WagetypeRefetch
                        t={this.props.t}
                        refetch={() => this.setState({ isLoadingWageTypes: true }, this.refetchWageType)}
                        lastUpdated={lastUpdated}
                        isLoading={isLoadingWageTypes}
                        dateTimeRules={this.props.commonStore.getDateTimeRules()}
                        extraNote={t(WAGE_TYPE_HOURLY_FALLBACK_NOTE)}
                        showAllWageTypes={showAllWageTypes}
                        onToggleShowAllWageTypes={(value) => this.setState({ showAllWageTypes: value })}
                    />
                }
                <TableWidget
                    headers={headers}
                    metaData={metaData}
                    data={tableData}
                    onChange={_ => { }}
                    minRemoveIndex={2}
                    className='mb-100'
                    customFormHandler={this.editAbsenceType}
                />
                <Modal
                    className={"modal right fade modal_revised"}
                    backdrop="static"
                    show={isEdit}
                    onHide={() => this.toggleModal(false, {})}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Absence')} {t('Type')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.toggleModal(false, {})}
                        />
                    </Modal.Header>
                    <Modal.Body className='position-relative'>
                        <AddEditAbsenceTypeForm
                            values={this.state.editData}
                            updateData={this.updateData}
                            onCancel={() => this.toggleModal(false, {})}
                            payroll_wagetypes={effectiveWageType}
                            // absenceCodes={absenceCode}
                            integrationType={commonStore?.config?.integration_details?.product}
                            t={this.props.t}
                            onSave={(data) => this.onSave(data)}
                        />
                    </Modal.Body>
                </Modal>
            </div >
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(AbsentTypes)));
